import Event from '../SnowplowEvent.js'

export const linkClick = new Event('iglu:com.credible.frontend/link_click/jsonschema/1-0-0', {
    text: 'text',
    url: 'href',
    activated: 'activated'
  }),
  ctaClick = new Event('iglu:com.credible.frontend/cta_click/jsonschema/1-0-0', {
    text: 'text',
    activated: 'activated'
  }),
  uploadFile = new Event('iglu:com.credible.frontend/upload_file/jsonschema/1-0-0', {
    documentName: 'name',
    errorMessage: 'error'
  }),
  fieldChange = new Event('iglu:com.credible.frontend/field_change/jsonschema/1-0-0', {
    fieldName: 'name',
    fieldValue: 'value',
    fieldLabel: 'label',
    errorMessage: 'error'
  }),
  formStepsSubmit = new Event('iglu:com.credible.frontend/form_step_submit/jsonschema/1-0-0', {
    text: 'text',
    invalidFields: 'invalidFields'
  }),
  faqQuestionClick = new Event('iglu:com.credible.frontend/faq_question_click/jsonschema/1-0-0', {
    question: 'text',
    action: 'action'
  }),
  headerItemClick = new Event('iglu:com.credible.frontend/header_item_click/jsonschema/1-0-0', {
    text: data => {
      if (data && ['collapse', 'expand'].includes(data.action)) {
        return 'title'
      } else {
        return 'text'
      }
    },
    type: data => {
      if (data && ['collapse', 'expand'].includes(data.action)) {
        return 'action'
      } else {
        return 'type'
      }
    }
  }),
  lenderLoginDetailCopy = new Event('iglu:com.credible.frontend/lender_login_detail_copy/jsonschema/1-0-0'),
  modalInteraction = new Event('iglu:com.credible.frontend/modal_interaction/jsonschema/1-0-0', {action: 'action'}),
  referralModuleInteraction = new Event('iglu:com.credible.frontend/referral_module_interaction/jsonschema/1-0-0', {action: 'action'}),
  supportClick = new Event('iglu:com.credible.frontend/support_click/jsonschema/1-0-0'),
  tabClick = new Event('iglu:com.credible.frontend/tab_click/jsonschema/1-0-0', {text: 'text'}),
  timelineStepClick = new Event('iglu:com.credible.frontend/timeline_step_click/jsonschema/1-0-0', {
    step: 'title',
    action: 'action'
  }),
  tooltipInteraction = new Event('iglu:com.credible.frontend/tooltip_interaction/jsonschema/1-0-0', {
    contentSubject: 'content',
    action: 'action'
  }),
  partnersWidgetInViewport = new Event('iglu:com.credible.frontend/partners_widget_in_viewport/jsonschema/1-0-0', {widgetDescription: 'widgetDescription'}),
  collapsibleClick = new Event('iglu:com.credible.frontend/collapsible_click/jsonschema/1-0-0', {
    text: 'text',
    action: 'action'
  }),
  elementRender = new Event('iglu:com.credible.frontend/element_render/jsonschema/1-0-0', {
    name: 'name',
    description: 'description'
  }),
  productTileInView = new Event('iglu:com.credible.frontend/product_tile_in_view/jsonschema/1-0-0')

export default {
  linkClick,
  ctaClick,
  uploadFile,
  fieldChange,
  formStepsSubmit,
  faqQuestionClick,
  headerItemClick,
  lenderLoginDetailCopy,
  modalInteraction,
  referralModuleInteraction,
  supportClick,
  tabClick,
  partnersWidgetInViewport,
  timelineStepClick,
  tooltipInteraction,
  collapsibleClick,
  elementRender,
  productTileInView
}
